import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import Select from 'react-select';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { CModal } from '@coreui/react';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import dayjs from 'dayjs';
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useNavigate } from 'react-router-dom';
import ViewImageAndText from '../../components/ViewImageAndText';
import { assignExamFormValidation, assignExamFormResultShowValidation, assignExamFormValidationRandomPassword, assignExamFormResultShowValidationRandomPassword, assignExamFormValidationPasswordManualReExamPasswordManual, assignExamFormValidationPasswordManualReExamPasswordAuto, assignExamFormValidationRandomPasswordManualReExamPassword, assignExamFormValidationRandomPasswordRandomReExamPassword, assignExamFormResultShowValidationPasswordManualReExamPasswordManual, assignExamFormResultShowValidationPasswordManualReExamPasswordAuto, assignExamFormResultShowValidationRandomPasswordManualReExamPassword, assignExamFormResultShowValidationRandomPasswordAutonReExamPassword } from '../../validation/Validation';
import { ZodError } from 'zod';
import { ErrorMessage } from '../../validation/validationError';
import { Loader } from '../../components/ModalsCommonFunctions';
import { ImageModal } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const AssignExam = () => {
    const authorizedAxios = generateAxiosInstance()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const sectionMasterId = localStorage.getItem("sectionMasterId")
    const sectionType = localStorage.getItem("sectionType");
    const [month, setMonth] = useState(moment().format('YYYY-MM'));
    const [start_date, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [end_date, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    const initialState = {
        class_id: "",
        divisions: [],
        end_date: "",
        end_time: "",
        exam_id: "",
        exam_total_time: "",
        pattern_id: "",
        test_type_id: "",
        ideal_time_per_question: "",
        negative_marks: "",
        passing_marks: "",
        password_type: "R",
        password: "",
        re_exam_password_type: "R",
        re_exam_password: "",
        positive_marks: "",
        start_date: "",
        start_time: "",
        subject_id: "",
        section_id: sectionMasterId,
        total_exam_marks: "",
        total_questions: "",
        result_show: false,
        result_publish_date: '',
        result_publish_time: '',
        exam_mode: 1
    }
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const [examPattern, setExamPattern] = useState([])
    const [examType, setExamType] = useState()
    const [visible, setVisible] = useState(false)
    const [visibleView, setVisibleView] = useState(false)
    const [viewPdfUrl, setviewPdfUrl] = useState('')
    const [viewPdf, setViewPdf] = useState(false);

    const [editId, setEditId] = useState(null)
    const [gradeList, setGradeList] = useState(null)
    const [divisionList, setDivisionList] = useState(null)
    const [divisionSelectList, setSelectDivisionList] = useState(null)
    const [examData, setExamData] = useState([])
    const [assignExamData, setAssignExamData] = useState(initialState)
    const [modalImageSrc, setModalImageSrc] = useState('')
    const [visibleImage, setVisibleImage] = useState(false)
    const today = new Date().toISOString().split('T')[0];
    const currentTime = dayjs().format('h:mm A');
    const [minEndDate, setMinEndDate] = useState(today);
    const [examAssignId, setExamAssignId] = useState(null)
    const [examDetails, setExamDetails] = useState([])
    const [errors, setErrors] = useState([]);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [examNameSort, setExamNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = [
        "exam_name",
        "description",
        "InstituteGradeMaster.gradeName",
        "uploadPdfExamSubjects.subjectMaster.subjectName",
        "subjectMaster.subjectName",
        "instituteSubjectMaster.subjectName",
        "ExamUploadQuestion.subjectMaster.subjectName",
        "ExamUploadQuestion.instituteSubjectMaster.subjectName",
        "ExamMasterQuestions.subjectMaster.subjectName",
        "ExamMasterQuestions.instituteSubjectMaster.subjectName"
    ];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getGradeList()
    }, []);

    useEffect(() => {
        getExamMasterList()
    }, [month])

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getExamMasterList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setExamData(await searchArray("B", `exam-masters?section_id=${sectionMasterId}&start_date=${start_date}&end_date=${end_date}`, searchKeys, searchValue.trim(), "data"));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(examData, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(examData.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > examData.length) {
            endIndex = examData.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(examData.slice(startIndex, endIndex));
    }, [examData, currPage, itemsPerPage]);

    const handleMonth = (newMonth) => {
        setMonth(newMonth ? newMonth.format('YYYY-MM') : '');
        setStartDate(newMonth.startOf('month').format('YYYY-MM-DD'));
        setEndDate(newMonth.endOf('month').format('YYYY-MM-DD'));
    };

    const getExamMasterList = async () => {
        try {
            // setLoading(true);
            const apiUrl2 = `exam-masters?section_id=${sectionMasterId}&start_date=${start_date}&end_date=${end_date}`;
            const response = await authorizedAxiosSection.get(apiUrl2);
            setExamData(response.data.data)
        } catch (error) {
            setExamData([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } //finally {
        //     setLoading(false);
        // }
    }

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    function convertTo24Hour(time12h) {
        const [time, modifier] = time12h.split(' ');
        let [hours, minutes] = time.split(':');

        hours = parseInt(hours, 10);

        if (modifier === 'AM' && hours === 12) {
            hours = 0; // Midnight edge case
        } else if (modifier === 'PM' && hours !== 12) {
            hours += 12; // PM times other than 12 PM
        }

        // Ensure hours are always two digits
        hours = hours.toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    }

    useEffect(() => {
        if (assignExamData.start_date && new Date(assignExamData.start_date) > new Date(today)) {
            setMinEndDate(assignExamData.start_date);
        } else {
            setMinEndDate(today);
        }
    }, [assignExamData.start_date]);

    function calculateTotalTime() {
        try {
            for (const [key, value] of Object.entries(assignExamData)) {
                if (key === "start_date" && value === today && dayjs(assignExamData.start_time, 'h:mm A').isBefore(dayjs(currentTime, 'h:mm A'))) {
                    throw new Error("Start time cannot be earlier than the current time");
                }

                if ((key === "start_date" || key === "end_date" || key === "start_time" || key === "end_time")
                    && assignExamData.start_date === assignExamData.end_date
                    && dayjs(assignExamData.end_time, 'h:mm A').isBefore(dayjs(assignExamData.start_time, 'h:mm A'))) {
                    throw new Error("End time cannot be earlier than the start time");
                }
            }
            const startTime24h = convertTo24Hour(assignExamData.start_time);
            const endTime24h = convertTo24Hour(assignExamData.end_time);

            const startDate = new Date(assignExamData.start_date + 'T' + startTime24h);
            const endDate = new Date(assignExamData.end_date + 'T' + endTime24h);

            // Check if end time is before start time, indicating it spans to the next day
            if (endDate < startDate) {
                endDate.setDate(endDate.getDate() + 1); // Add a day to the end date
            }

            // Calculate the difference in milliseconds
            const timeDiff = endDate.getTime() - startDate.getTime();

            // Convert milliseconds to minutes
            const totalTimeInMinutes = timeDiff / (1000 * 60);

            // If the calculated time is invalid, set to 0
            const validTotalTime = isNaN(totalTimeInMinutes) ? 0 : totalTimeInMinutes;

            setAssignExamData((prevData) => {
                return {
                    ...prevData,
                    exam_total_time: validTotalTime
                }
            });
        } catch (error) {
            setAssignExamData((prevData) => {
                return {
                    ...prevData,
                    exam_total_time: 0
                }
            });
        }
    }

    const handleGradeChange = (e, index) => {
        setAssignExamData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value

            }
        })

        if (e.target.value.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
        }

        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleEditGradeChange = (classId) => {
        setAssignExamData((prevData) => {
            return {
                ...prevData,
                class_id: classId
            }
        })

        // if (e.target.value.trim() !== '') {
        //     setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
        // }

        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${classId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        setSelectDivisionList(divisionList?.map((i) => {
            return {
                value: i.id,
                label: i.divisionName
            }
        }))
    }, [divisionList])

    const handleInputStartTimeChange = (time) => {
        const formattedTime = dayjs(time).format('h:mm A');
        setAssignExamData((prevData) => ({
            ...prevData,
            start_time: formattedTime
        }));

        if (formattedTime.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== "start_time"));
        }
    };

    const handleInputEndTimeChange = (time) => {
        const formattedTime = dayjs(time).format('h:mm A');
        setAssignExamData((prevData) => ({
            ...prevData,
            end_time: formattedTime
        }));

        if (formattedTime.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== "end_time"));
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked, options } = e.target;
        setAssignExamData((prevData) => {
            if (type === 'checkbox') {
                return {
                    ...prevData,
                    [name]: checked,
                };
            } else {
                return {
                    ...prevData,
                    [name]: value,
                };
            }
        })

        // Clear the error for the specific field being edited
        if (name === "result_show" && checked == true) {
            if (value.trim() !== '') {
                setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== "result_publish_date" && error.path[0] !== "result_publish_time"));
            }
        } else if (value.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const getSubjectIds = (exam) => {
        const subjectIds = new Set();

        // Check if the exam is a PDF exam
        if (exam.is_pdf_exam === "Y") {
            if (exam.uploadPdfExamSubjects) {
                exam.uploadPdfExamSubjects.forEach(q => {
                    if (q.subjectMaster?.id) subjectIds.add(q.subjectMaster.id);
                });
            }

            // If subject IDs from uploadPdfExamSubjects are found, return them
            if (subjectIds.size > 0) {
                return Array.from(subjectIds);
            }
        }

        // Determine subject IDs based on competitive exam or syllabus structure
        if (exam.is_competitive === 'Y') {
            if (exam?.competitive_exam_type === "A") {
                if (exam?.subjectMaster?.id) subjectIds.add(exam.subjectMaster.id);
                // if (exam?.instituteSubjectMaster?.id) subjectIds.add(exam.instituteSubjectMaster.id);
            } else {
                if (exam?.instituteSubjectMaster?.id) subjectIds.add(exam.instituteSubjectMaster.id);
            }
        } else {
            if (exam?.syllabus_structure_type === "A") {
                if (exam?.subjectMaster?.id) subjectIds.add(exam.subjectMaster.id);
                // if (exam?.instituteSubjectMaster?.id) subjectIds.add(exam.instituteSubjectMaster.id);
            } else {
                if (exam?.instituteSubjectMaster?.id) subjectIds.add(exam.instituteSubjectMaster.id);
            }
        }

        // Collect subject IDs from ExamUploadQuestion
        // if (exam.ExamUploadQuestion) {
        //     exam.ExamUploadQuestion.forEach(q => {
        //         if (exam.is_competitive === 'Y') {
        //             if (exam?.competitive_exam_type === "A") {
        //                 if (q.subjectMaster?.id) subjectIds.add(q.subjectMaster.id);
        //             } else {
        //                 if (q.instituteSubjectMaster?.id) subjectIds.add(q.instituteSubjectMaster.id);
        //             }
        //         } else {
        //             if (exam?.syllabus_structure_type === "A") {
        //                 if (q.subjectMaster?.id) subjectIds.add(q.subjectMaster.id);
        //             } else {
        //                 if (q.instituteSubjectMaster?.id) subjectIds.add(q.instituteSubjectMaster.id);
        //             }
        //         }
        //     });
        // }

        if (exam.ExamUploadQuestion) {
            const type = exam.is_competitive === "Y" ? exam.competitive_exam_type : exam.syllabus_structure_type;

            exam.ExamUploadQuestion.forEach(q => {
                const id = type === "A" ? q.subjectMaster?.id : q.instituteSubjectMaster?.id;
                if (id) subjectIds.add(id);
            });
        }

        // // Collect subject IDs from ExamMasterQuestions
        // if (exam.ExamMasterQuestions) {
        //     exam.ExamMasterQuestions.forEach(q => {
        //         if (exam.is_competitive === 'Y') {
        //             if (exam?.competitive_exam_type === "A") {
        //                 if (q.subjectMaster?.id) subjectIds.add(q.subjectMaster.id);
        //             } else {
        //                 if (q.instituteSubjectMaster?.id) subjectIds.add(q.instituteSubjectMaster.id);
        //             }
        //         } else {
        //             if (exam?.syllabus_structure_type === "A") {
        //                 if (q.subjectMaster?.id) subjectIds.add(q.subjectMaster.id);
        //             } else {
        //                 if (q.instituteSubjectMaster?.id) subjectIds.add(q.instituteSubjectMaster.id);
        //             }
        //         }
        //     });
        // }

        if (exam.ExamMasterQuestions) {
            const type = exam.is_competitive === "Y" ? exam.competitive_exam_type : exam.syllabus_structure_type;

            exam.ExamMasterQuestions.forEach(q => {
                const id = type === "A" ? q.subjectMaster?.id : q.instituteSubjectMaster?.id;
                if (id) subjectIds.add(id);
            });
        }

        // Convert the Set to an array and return
        return Array.from(subjectIds);
    };

    const getSubjectType = (exam) => {
        // PDF exam
        if (exam.is_pdf_exam === "Y" && exam.uploadPdfExamSubjects) {
            for (const q of exam.uploadPdfExamSubjects) {
                if (q.subjectMaster?.id) return "A";
                // if (q.instituteSubjectMaster?.id) return "I";
            }
        }

        // Competitive / syllabus
        if (exam.is_competitive === "Y") {
            if (exam?.competitive_exam_type === "A") {
                if (exam?.subjectMaster?.id) return "A";
            } else {
                if (exam?.instituteSubjectMaster?.id) return "I";
            }
        } else {
            if (exam?.syllabus_structure_type === "A") {
                if (exam?.subjectMaster?.id) return "A";
            } else {
                if (exam?.instituteSubjectMaster?.id) return "I";
            }
        }

        // ExamUploadQuestion
        if (exam.ExamUploadQuestion) {
            for (const q of exam.ExamUploadQuestion) {
                if (q.subjectMaster?.id) return "A";
                if (q.instituteSubjectMaster?.id) return "I";
            }
        }

        // ExamMasterQuestions
        if (exam.ExamMasterQuestions) {
            for (const q of exam.ExamMasterQuestions) {
                if (q.subjectMaster?.id) return "A";
                if (q.instituteSubjectMaster?.id) return "I";
            }
        }

        return null; // nothing found
    };

    useEffect(() => {
    //     const apiUrl2 = `/exam-patterns`;
    //     authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl2)
    //         .then(response => {
    //             setExamPattern(response.data.data)
    //         })
    //         .catch(error => {
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //             console.error('Error fetching data:', errorMsg);
    //         });

        const apiUrl3 = `/get-exam-master`;
        authorizedAxios && authorizedAxios.get(apiUrl3)
            .then(response => {
                setExamType(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, [])

    const getExamPattern = (subjectIds, subjectType) => {
        // if (sectionType === "school") {
            const apiUrl = `/exam-patterns`;
            authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl)
                .then(response => {
                    setExamPattern(response.data.data)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        // } else if (sectionType === "class") {
        //     const apiUrl = `/get-paper-pattern-by-filters`;
        //     authorizedAxios && authorizedAxios.post(apiUrl, { subjectMasterIds: subjectIds, subjectType })
        //         .then(response => {
        //             setExamPattern(response.data.result)
        //         })
        //         .catch(error => {
        //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        //             console.error('Error fetching data:', errorMsg);
        //         });
        // }
    }

    const handleInputExam = (e) => {
        const data = examData.filter((i) => i.id == e)
        const subjectIds = getSubjectIds(data[0]);
        const subjectType = getSubjectType(data[0]);

        setAssignExamData((prevData) => {
            return {
                ...prevData,
                exam_id: e,
                total_questions: data[0].total_questions,
                // subject_id: data[0].subject_id,
                subject_id: subjectIds,
                // negative_marks: data[0]?.ExamPattern?.pernegetive_question_marks,
                // positive_marks: data[0]?.ExamPattern?.perquestion_marks
            }
        })

        getExamPattern(subjectIds, subjectType);
    }

    const getExamName = (exam_id) => {
        if (!examData || examData.length === 0) {
            return ''; // Return an empty string if examData is empty or undefined
        }
        const exam = examData.find((item) => item.id === exam_id);
        return exam ? exam.exam_name : '';
    };

    const handleViewExamUpload = (e) => {
        const apiUrl = `/exam-upload-baseline-questions/${e}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setExamDetails(response.data.questions)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleViewExamCreate = (e) => {
        const apiUrl = `/exam-manual-questions/${e}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setExamDetails(response.data.questions)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handlePatternChange = (e) => {
        const data = examPattern.filter((i) => i.id == e.target.value)
        setAssignExamData((prevData) => {
            return {
                ...prevData,
                // exam_id: e,
                // total_questions: data[0].total_questions,
                // subject_id: data[0].subject_id,
                pattern_id: e.target.value,
                negative_marks: data[0]?.pernegetive_question_marks,
                positive_marks: data[0]?.perquestion_marks,
                total_exam_marks: data[0]?.perquestion_marks * assignExamData?.total_questions
            }
        })

        if (e.target.value.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
        }
    }

    const handleChangeDivision = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setAssignExamData((prevData) => {
            return {
                ...prevData,
                divisions: selectedIds,
            }
        })

        if (selectedIds.length > 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== "divisions"));
        }
    }

    const handleInputResultPublishTimeChange = (time) => {
        const formattedTime = dayjs(time).format('h:mm A');
        setAssignExamData((prevData) => ({
            ...prevData,
            result_publish_time: formattedTime
        }));

        if (formattedTime !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== "result_publish_time"));
        }
    };

    useEffect(() => {
        if (assignExamData.result_show) {
            if (assignExamData.result_publish_date !== "") {
                setAssignExamData((prevData) => ({
                    ...prevData,
                    result_publish_date: '',
                }));
            }
            if (assignExamData.result_publish_time !== "") {
                setAssignExamData((prevData) => ({
                    ...prevData,
                    result_publish_time: '',
                }));
            }
        }
    }, [assignExamData.result_show]);

    const assignExam = async () => {
        try {
            if (assignExamData.result_show) {
                if (assignExamData.password_type === "M") {
                    if (assignExamData.re_exam_password_type === "M") {
                        await assignExamFormValidationPasswordManualReExamPasswordManual.parseAsync(assignExamData);
                    } else {
                        await assignExamFormValidationPasswordManualReExamPasswordAuto.parseAsync(assignExamData);
                    }
                } else {
                    if (assignExamData.re_exam_password_type === "M") {
                        await assignExamFormValidationRandomPasswordManualReExamPassword.parseAsync(assignExamData);
                    } else {
                        await assignExamFormValidationRandomPasswordRandomReExamPassword.parseAsync(assignExamData);
                    }
                }
            } else {
                if (assignExamData.password_type === "M") {
                    if (assignExamData.re_exam_password_type === "M") {
                        await assignExamFormResultShowValidationPasswordManualReExamPasswordManual.parseAsync(assignExamData);
                    } else {
                        await assignExamFormResultShowValidationPasswordManualReExamPasswordAuto.parseAsync(assignExamData);
                    }
                } else {
                    if (assignExamData.re_exam_password_type === "M") {
                        await assignExamFormResultShowValidationRandomPasswordManualReExamPassword.parseAsync(assignExamData);
                    } else {
                        await assignExamFormResultShowValidationRandomPasswordAutonReExamPassword.parseAsync(assignExamData);
                    }
                }
            }

            let newErrors = [];
            for (const [key, value] of Object.entries(assignExamData)) {
                if (key === "start_date" && value === today && dayjs(assignExamData.start_time, 'h:mm A').isBefore(dayjs(currentTime, 'h:mm A'))) {
                    const errorIndex = newErrors.findIndex(err => err.path.includes("start_time"));
                    const errorMessage = "Start time cannot be earlier than the current time";

                    if (errorIndex !== -1) {
                        // Update error message if it already exists
                        newErrors[errorIndex].message = errorMessage;
                    } else {
                        // Add new error message
                        newErrors.push({ path: ["start_time"], message: errorMessage });
                    }
                }

                if ((key === "start_date" || key === "end_date" || key === "start_time" || key === "end_time")
                    && assignExamData.start_date === assignExamData.end_date
                    && dayjs(assignExamData.end_time, 'h:mm A').isBefore(dayjs(assignExamData.start_time, 'h:mm A'))) {

                    const errorIndex = newErrors.findIndex(err => err.path.includes("end_time"));
                    const errorMessage = "End time cannot be earlier than the start time";

                    if (errorIndex !== -1) {
                        // Update error message if it already exists
                        newErrors[errorIndex].message = errorMessage;
                    } else {
                        // Add new error message
                        newErrors.push({ path: ["end_time"], message: errorMessage });
                    }
                }

                if ((key === "start_date" || key === "end_date" || key === "start_time" || key === "end_time")
                    && assignExamData.start_date === assignExamData.end_date
                    && dayjs(assignExamData.end_time, 'h:mm A').isSame(dayjs(assignExamData.start_time, 'h:mm A'))) {

                    const errorStartTimeIndex = newErrors.findIndex(err => err.path.includes("start_time"));
                    const errorEndTimeIndex = newErrors.findIndex(err => err.path.includes("end_time"));
                    const errorMessage = "Start time and end time cannot be the same";

                    if (errorEndTimeIndex !== -1) {
                        newErrors[errorStartTimeIndex].message = errorMessage;
                        newErrors[errorEndTimeIndex].message = errorMessage;
                    } else {
                        newErrors.push({ path: ["start_time"], message: errorMessage });
                        newErrors.push({ path: ["end_time"], message: errorMessage });
                    }
                }

                if (key === "passing_marks" && assignExamData.passing_marks > assignExamData.total_exam_marks) {
                    const errorIndex = newErrors.findIndex(err => err.path.includes("passing_marks"));
                    const errorMessage = "Passing marks cannot be greater than total marks";

                    if (errorIndex !== -1) {
                        // Update error message if it already exists
                        newErrors[errorIndex].message = errorMessage;
                    } else {
                        // Add new error message
                        newErrors.push({ path: ["passing_marks"], message: errorMessage });
                    }
                }
            }

            if (newErrors.length > 0) {
                setErrors(newErrors);
                return;
            } else {
                setErrors([]);
            }

            const mergedData = {
                ...assignExamData,
            };

            // Remove result_publish_date and result_publish_time keys from mergedData
            delete mergedData.result_publish_date;
            delete mergedData.result_publish_time;

            // Check if result_show is false
            if (!assignExamData.result_show) {
                // Parse the time and convert it to 24-hour format
                const parsedTime = dayjs(assignExamData.result_publish_time, 'h:mm A');
                const time24HourFormat = parsedTime.format('HH:mm');

                // Combine date and time into one string
                const combinedDateTime = `${assignExamData.result_publish_date} ${time24HourFormat}`;

                // Add result_publish_date_time key to mergedData
                mergedData.result_publish_date_time = combinedDateTime;
            }

            setLoading(true);

            const apiUrl = `/exams-assign`;
            const response = await authorizedAxiosSection.post(apiUrl, mergedData);

            setVisible(false);
            setAssignExamData(initialState);
            await getExamMasterList();
            setSaveId(response.data.data.exam_id);
            setExamNameSort(null);

            Swal.fire({ text: response.data.message });
        } catch (error) {
            if (error instanceof ZodError) {
                let newErrors = [...error.errors];
                for (const [key, value] of Object.entries(assignExamData)) {
                    if (key === "start_date" && value === today && dayjs(assignExamData.start_time, 'h:mm A').isBefore(dayjs(currentTime, 'h:mm A'))) {
                        const errorIndex = newErrors.findIndex(err => err.path.includes("start_time"));
                        const errorMessage = "Start time cannot be earlier than the current time";

                        if (errorIndex !== -1) {
                            newErrors[errorIndex].message = errorMessage;
                        } else {
                            newErrors.push({ path: ["start_time"], message: errorMessage });
                        }
                    }

                    if ((key === "start_date" || key === "end_date" || key === "start_time" || key === "end_time")
                        && assignExamData.start_date === assignExamData.end_date
                        && dayjs(assignExamData.end_time, 'h:mm A').isBefore(dayjs(assignExamData.start_time, 'h:mm A'))) {

                        const errorIndex = newErrors.findIndex(err => err.path.includes("end_time"));
                        const errorMessage = "End time cannot be earlier than the start time";

                        if (errorIndex !== -1) {
                            newErrors[errorIndex].message = errorMessage;
                        } else {
                            newErrors.push({ path: ["end_time"], message: errorMessage });
                        }
                    }

                    if ((key === "start_date" || key === "end_date" || key === "start_time" || key === "end_time")
                        && assignExamData.start_date === assignExamData.end_date
                        && dayjs(assignExamData.end_time, 'h:mm A').isSame(dayjs(assignExamData.start_time, 'h:mm A'))) {

                        const errorStartTimeIndex = newErrors.findIndex(err => err.path.includes("start_time"));
                        const errorEndTimeIndex = newErrors.findIndex(err => err.path.includes("end_time"));
                        const errorMessage = "Start time and end time cannot be the same";

                        if (errorEndTimeIndex !== -1) {
                            newErrors[errorStartTimeIndex].message = errorMessage;
                            newErrors[errorEndTimeIndex].message = errorMessage;
                        } else {
                            newErrors.push({ path: ["start_time"], message: errorMessage });
                            newErrors.push({ path: ["end_time"], message: errorMessage });
                        }
                    }

                    if (key === "passing_marks" && assignExamData.passing_marks > assignExamData.total_exam_marks) {
                        const errorIndex = newErrors.findIndex(err => err.path.includes("passing_marks"));
                        const errorMessage = "Passing marks cannot be greater than total marks";

                        if (errorIndex !== -1) {
                            // Update error message if it already exists
                            newErrors[errorIndex].message = errorMessage;
                        } else {
                            // Add new error message
                            newErrors.push({ path: ["passing_marks"], message: errorMessage });
                        }
                    }
                }
                setErrors(newErrors); // Set validation errors
            } else {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            }
        } finally {
            setLoading(false);
        }
    }

    // const deleteAssignedExam = (id) => {
    //     let confirmed = window.confirm('Are you sure? you want to delete this record.');
    //     if (confirmed) {
    //         setLoading(true);
    //         const apiUrl = `/assigned-exams?exam_id=${id}`;
    //         authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
    //             .then(response => {
    //                 setExamData((prevCourses) => [...prevCourses].filter((exam) => exam.id != id));
    //                 Swal.fire(
    //                     { text: response.data.message }
    //                 );
    //             })
    //             .catch(error => {
    //                 const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //                 Swal.fire(
    //                     { text: errorMsg }
    //                 );
    //             })
    //             .finally(() => {
    //                 setLoading(false); // End loading
    //             });
    //     }
    // }

    const deleteAssignedExam = async (id) => {
        let confirmed = window.confirm('Are you sure? You want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/assigned-exams?exam_id=${id}`;

            try {
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, examData.length);
                await getExamMasterList();
                setCurrPage(page);
                // setExamData((prevCourses) => prevCourses.filter((exam) => exam.id !== id));
                Swal.fire({ text: response.data.message });
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false); // End loading
            }
        }
    };


    // const deleteCreateExam = (id) => {
    //     let confirmed = window.confirm('Are you sure? you want to delete this record.');
    //     if (confirmed) {
    //         setLoading(true);
    //         const apiUrl = `/exam-masters?exam_id=${id}`;
    //         authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
    //             .then(response => {
    //                 setExamData((prevCourses) => [...prevCourses].filter((exam) => exam.id != id));
    //                 Swal.fire(
    //                     { text: response.data.message }
    //                 );
    //             })
    //             .catch(error => {
    //                 const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //                 Swal.fire(
    //                     { text: errorMsg }
    //                 );
    //             })
    //             .finally(() => {
    //                 setLoading(false);
    //             });
    //     }
    // }

    const deleteCreateExam = async (id) => {
        let confirmed = window.confirm('Are you sure? You want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/exam-masters?exam_id=${id}`;

            try {
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, examData.length);
                await getExamMasterList();
                setCurrPage(page);
                // setExamData((prevCourses) => prevCourses.filter((exam) => exam.id !== id));
                Swal.fire({ text: response.data.message });
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false);
            }
        }
    };


    // const updateExam = () => {
    //     const mergedData = {
    //         ...assignExamData,
    //     };

    //     // Remove result_publish_date and result_publish_time keys from mergedData
    //     delete mergedData.result_publish_date;
    //     delete mergedData.result_publish_time;
    //     mergedData.examAssignId = examAssignId;

    //     // Check if result_show is false
    //     if (!assignExamData.result_show) {
    //         // Parse the time and convert it to 24-hour format
    //         const parsedTime = dayjs(assignExamData.result_publish_time, 'h:mm A');
    //         const time24HourFormat = parsedTime.format('HH:mm');

    //         // Combine date and time into one string
    //         const combinedDateTime = `${assignExamData.result_publish_date} ${time24HourFormat}`;

    //         // Add result_publish_date_time key to mergedData
    //         mergedData.result_publish_date_time = combinedDateTime;
    //     }

    //     setLoading(true);

    //     const apiUrl = `/edit-exams-assign`;
    //     authorizedAxiosSection && authorizedAxiosSection.put(apiUrl, mergedData)
    //         .then(response => {
    //             setAssignExamData(initialState)
    //             getExamMasterList();
    //             setExamAssignId(null);
    //             setVisible(false);

    //             Swal.fire(
    //                 { text: response.data.message }
    //             );
    //         })
    //         .catch(error => {
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //             Swal.fire(
    //                 { text: errorMsg }
    //             );
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // }

    const updateExam = async () => {
        const mergedData = {
            ...assignExamData,
        };

        // Remove result_publish_date and result_publish_time keys from mergedData
        delete mergedData.result_publish_date;
        delete mergedData.result_publish_time;
        mergedData.examAssignId = examAssignId;

        // Check if result_show is false
        if (!assignExamData.result_show) {
            // Parse the time and convert it to 24-hour format
            const parsedTime = dayjs(assignExamData.result_publish_time, 'h:mm A');
            const time24HourFormat = parsedTime.format('HH:mm');

            // Combine date and time into one string
            const combinedDateTime = `${assignExamData.result_publish_date} ${time24HourFormat}`;

            // Add result_publish_date_time key to mergedData
            mergedData.result_publish_date_time = combinedDateTime;
        }

        setLoading(true);

        try {
            const apiUrl = `/edit-exams-assign`;
            const response = await authorizedAxiosSection.put(apiUrl, mergedData);

            setAssignExamData(initialState);
            await getExamMasterList();
            setSaveId(response.data.data.exam_id);
            setExamNameSort(null);
            setExamAssignId(null);
            setVisible(false);

            Swal.fire({ text: response.data.message });
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (assignExamData.start_date.length != 0 && assignExamData.end_date.length != 0 && assignExamData.start_time.length != 0 && assignExamData.end_time.length != 0) {
            calculateTotalTime();
        }
    }, [assignExamData.start_time, assignExamData.end_time, assignExamData.start_date, assignExamData.end_date]);

    const formatDate = (dateTimeString) => {
        const datePart = dateTimeString.split('T')[0]; // Split at 'T' and take the first part
        return datePart;
    };

    const getTimeIn12HourFormat = (dateTimeString) => {
        let timeString = dateTimeString.split('T')[1];
        timeString = timeString.split('.')[0];

        let [hours, minutes] = timeString.split(':');
        let period = 'AM';

        hours = parseInt(hours, 10);
        if (hours >= 12) {
            period = 'PM';
            if (hours > 12) {
                hours -= 12;
            }
        } else if (hours === 0) {
            hours = 12;
        }

        return `${hours}:${minutes} ${period}`;
    };

    const getExamData = (id) => {
        setLoading(true);
        const apiUrl = `/assigned-exams?id=${id}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                const data = response.data.data[0];
                const division = data.ExamAssignDivisions.map(item => item.InstituteDivisionMaster.divisionName);
                setAssignExamData((prevData) => {
                    return {
                        ...prevData,
                        class_id: data.class_id,
                        divisions: data.ExamAssignDivisions.map(item => item.division_id.toString()),
                        end_date: formatDate(data.end_date),
                        end_time: data.end_time,
                        exam_id: data.exam_id,
                        exam_total_time: data.exam_total_time,
                        pattern_id: data.pattern_id,
                        test_type_id: data.test_type_id,
                        ideal_time_per_question: data.ideal_time_per_question,
                        negative_marks: data.negative_marks,
                        passing_marks: data.passing_marks,
                        password: data.password,
                        re_exam_password: data.randomPassword,
                        positive_marks: data.positive_marks,
                        start_date: formatDate(data.start_date),
                        start_time: data.start_time,
                        subject_id: data.subject_id,
                        section_id: data.section_id,
                        total_exam_marks: data.total_exam_marks,
                        total_questions: data.total_questions,
                        result_show: data.result_show,
                        result_publish_date: data.result_publish_date_time ? formatDate(data.result_publish_date_time) : null,
                        result_publish_time: data.result_publish_date_time ? getTimeIn12HourFormat(data.result_publish_date_time) : null
                    }
                })

                handleEditGradeChange(data.class_id)
                setVisible(!visible)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleReset = () => {
        setEditId(null);
        setAssignExamData(initialState);
        setExamNameSort(null);
        setErrors([]);
    }

    const handleFormClose = () => {
        setVisible(false);
        setEditId(null);
        setExamAssignId(null);
        setAssignExamData(initialState);
    }

    const getSubjectNames = (exam) => {
        // Check if the exam is a PDF exam
        if (exam.is_pdf_exam === "Y") {
            const pdfExamSubjectNames = [
                ...new Set(
                    exam.uploadPdfExamSubjects.map(q => q.subjectMaster?.subjectName).filter(Boolean)
                )
            ];

            // Return unique subject names from uploadPdfExamSubjects if found
            if (pdfExamSubjectNames.length > 0) {
                return pdfExamSubjectNames.join(", ");
            }
        }

        const subjectName = exam.is_competitive === 'Y'
            ? (
                exam?.competitive_exam_type === "A"
                    ? exam?.subjectMaster?.subjectName
                    : exam?.instituteSubjectMaster?.subjectName
            )
            : (
                exam?.syllabus_structure_type === "A"
                    ? exam?.subjectMaster?.subjectName
                    : exam?.instituteSubjectMaster?.subjectName
            );

        // If subjectName is not null, return it
        if (subjectName) {
            return subjectName;
        }

        // Check for subject names in ExamUploadQuestion if subjectName is null
        const uploadQuestionSubjectNames = [
            ...new Set(
                exam.ExamUploadQuestion.map(q =>
                    q.subjectMaster?.subjectName || q.instituteSubjectMaster?.subjectName
                ).filter(Boolean)
            )
        ];

        // If subject names found in ExamUploadQuestion, return them
        if (uploadQuestionSubjectNames.length > 0) {
            return uploadQuestionSubjectNames.join(", ");
        }

        // Check for subject names in ExamMasterQuestions if still null
        const masterQuestionSubjectNames = [
            ...new Set(
                exam.ExamMasterQuestions.map(q =>
                    q.subjectMaster?.subjectName || q.instituteSubjectMaster?.subjectName
                ).filter(Boolean)
            )
        ];

        // If subject names found in ExamMasterQuestions, return them
        if (masterQuestionSubjectNames.length > 0) {
            return masterQuestionSubjectNames.join(", ");
        }

        // Default fallback message if no subject names found
        return "No subjects available";
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Assign Exam</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-pen"></i>Assign Exam</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className='col-md-12'>
                                        <div className="row">
                                            <div className="col-md-12 full_wrap">
                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Month</label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={['year', 'month']}
                                                        value={dayjs(month)}
                                                        onChange={handleMonth}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="d-grid gap-2 mt-2">
                                            <div class="tab-content rounded-bottom custom_table">
                                                <div className='search_btn_row'>
                                                    <input
                                                        className="form-control mr-sm-2"
                                                        type="Search"
                                                        placeholder="Search"
                                                        value={searchValue}
                                                        onChange={handleEmptySearch}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter') {
                                                                handleSearch();
                                                            }
                                                        }}
                                                    />
                                                    <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                </div>
                                                <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" className='sl_no'>Sr. No.</th>
                                                                <th scope="col">
                                                                    Exam Name
                                                                    <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setExamData} setCurrPage={setCurrPage} sortingPath={"exam_name"} />
                                                                </th>
                                                                <th scope="col">Exam Description</th>
                                                                <th scope="col">Class </th>
                                                                <th scope="col">Subject</th>
                                                                <th scope="col">Assign Exam</th>
                                                                <th scope="col">Question Paper</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                displayedData?.length > 0 ?
                                                                    displayedData?.map((exam, index) => {
                                                                        return (
                                                                            <tr>
                                                                                <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                <td>{exam?.exam_name}</td>
                                                                                <td>{exam?.description}</td>
                                                                                <td>{exam?.InstituteGradeMaster?.gradeName}</td>
                                                                                <td>
                                                                                    {/* {exam.is_competitive === 'Y' ?
                                                                                        exam?.competitive_exam_type == "A" ? exam?.subjectMaster?.subjectName : exam?.instituteSubjectMaster?.subjectName
                                                                                        :
                                                                                        exam?.syllabus_structure_type == "A" ? exam?.subjectMaster?.subjectName : exam?.instituteSubjectMaster?.subjectName} */}


                                                                                    {getSubjectNames(exam)}
                                                                                </td>
                                                                                <td><button className='btn btn-success' disabled={exam?.is_exam_assigned == "Y"} onClick={() => { handleInputExam(exam.id); setVisible(!visible) }}>Assign Exam</button></td>
                                                                                <td>
                                                                                    {exam.exam_type == "U" && <button className='btn btn-success' /*disabled={exam?.is_exam_assigned != "Y"}*/ onClick={() => { handleViewExamUpload(exam.id); setVisibleView(!visible) }}>View</button>}
                                                                                    {(exam.exam_type == "" || exam.exam_type == "M" || exam.exam_type == "R") && <button className='btn btn-success' /*disabled={exam?.is_exam_assigned != "Y"}*/ onClick={() => { handleViewExamCreate(exam.id); setVisibleView(!visible) }}>View</button>}
                                                                                    {(exam.is_pdf_exam === 'Y') && <button className='btn btn-success' onClick={() => { setviewPdfUrl(exam.pdf_url); setViewPdf(!viewPdf) }}>View</button>}
                                                                                </td>

                                                                                <td>
                                                                                    {
                                                                                        exam.ExamAssign.length > 0 ?
                                                                                            (
                                                                                                exam.ExamAssign[0].start_date.split('T')[0] > today ?
                                                                                                    <button className="btn btn-outline-warning edit_icon" type="button"
                                                                                                        onClick={() => {
                                                                                                            getExamData(exam.id)
                                                                                                            setEditId(exam.id);
                                                                                                            setExamAssignId(exam.ExamAssign[0].id);
                                                                                                        }}>
                                                                                                        <i class="fa-light fa-pen-to-square"></i>
                                                                                                    </button>
                                                                                                    :
                                                                                                    (
                                                                                                        exam.ExamAssign[0].start_date.split('T')[0] === today ?
                                                                                                            (
                                                                                                                dayjs(exam.ExamAssign[0].start_time, 'h:mm A').isAfter(dayjs(currentTime, 'h:mm A')) ?
                                                                                                                    <button className="btn btn-outline-warning edit_icon" type="button"
                                                                                                                        onClick={() => {
                                                                                                                            getExamData(exam.id)
                                                                                                                            setEditId(exam.id);
                                                                                                                            setExamAssignId(exam.ExamAssign[0].id);
                                                                                                                        }}>
                                                                                                                        <i class="fa-light fa-pen-to-square"></i>
                                                                                                                    </button>
                                                                                                                    :
                                                                                                                    <button className="btn btn-outline-warning edit_icon" disabled type="button"
                                                                                                                        onClick={() => {
                                                                                                                            Swal.fire({
                                                                                                                                text: "Exam Start Time is Expired"
                                                                                                                            })
                                                                                                                        }}>
                                                                                                                        <i class="fa-light fa-pen-to-square"></i>
                                                                                                                    </button>
                                                                                                            )
                                                                                                            :
                                                                                                            <button className="btn btn-outline-warning edit_icon" disabled type="button"
                                                                                                                onClick={() => {
                                                                                                                    Swal.fire({
                                                                                                                        text: "Exam Start Date is Expired"
                                                                                                                    })
                                                                                                                }}>
                                                                                                                <i class="fa-light fa-pen-to-square"></i>
                                                                                                            </button>
                                                                                                    )
                                                                                            )
                                                                                            :
                                                                                            <button className="btn btn-outline-warning edit_icon" disabled type="button"
                                                                                                onClick={() => {
                                                                                                    Swal.fire({
                                                                                                        text: "Please Assign Exam"
                                                                                                    })
                                                                                                }}>
                                                                                                <i class="fa-light fa-pen-to-square"></i>
                                                                                            </button>
                                                                                    }
                                                                                    {exam?.is_exam_assigned == "Y" ?
                                                                                        <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteAssignedExam(exam.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        :
                                                                                        <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteCreateExam(exam.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                    }
                                                                                </td>

                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    (<tr>
                                                                        <th colspan={"100%"} style={{ textAlign: 'center' }}>No Exams Available</th>
                                                                    </tr>)
                                                            }
                                                        </tbody>
                                                    </table>
                                                    <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={examData.length} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <CModal
                backdrop="static"
                visible={visible}
                onClose={() => { setVisible(false); setAssignExamData(initialState); setEditId(null); setErrors([]); }}
                aria-labelledby="LiveDemoExampleLabel"
                onIni className='assign-modal'
            >
                <div className="row">
                    <div className='popoup-title text-center w-100'><h3>Assign Exam</h3></div>
                    <button type="button" className="btn-close" aria-label="Close" onClick={handleFormClose}></button>
                </div>

                <div className="row">
                    <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Start Date</label>
                        <input type="date" className="form-control" id="start_date" name='start_date' value={assignExamData.start_date} min={today} onChange={handleInputChange} />
                        <ErrorMessage errors={errors} field="start_date" />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="start_time" className="col-form-label"><span style={{ color: "red" }}>*</span>Start Time</label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['TimePicker', 'TimePicker']}>
                                <TimePicker
                                    value={dayjs(assignExamData.start_time, 'h:mm A')}
                                    onChange={(newTime) => handleInputStartTimeChange(newTime)}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                        <ErrorMessage errors={errors} field="start_time" />
                    </div>

                    <div className="col-md-6 ">
                        <label for="end_date" className="col-form-label"><span style={{ color: "red" }}>*</span>End Date</label>
                        <input type="date" className="form-control" id="end_date" name='end_date' value={assignExamData.end_date} min={minEndDate} onChange={handleInputChange} />
                        <ErrorMessage errors={errors} field="end_date" />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="start_time" className="col-form-label"><span style={{ color: "red" }}>*</span>End Time</label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['TimePicker', 'TimePicker']}>
                                <TimePicker
                                    value={dayjs(assignExamData.end_time, 'h:mm A')}
                                    onChange={(newTime) => handleInputEndTimeChange(newTime)}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                        <ErrorMessage errors={errors} field="end_time" />
                    </div>

                    <div className="col-md-6 ">
                        <label for="exam_total_time" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Total Time (minutes)</label>
                        <input type="text" className="form-control" id="exam_total_time" name='exam_total_time' disabled value={assignExamData.exam_total_time} onChange={(e) => { handleInputChange(e) }} />
                    </div>

                    <div className="col-md-6">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Pattern</label>
                        <select class="form-select" aria-label="Default select example" name='pattern_id' onChange={handlePatternChange} value={assignExamData.pattern_id}>
                            <option selected value={''} disabled>Select Pattern</option>
                            {
                                examPattern?.map((pattern) => {
                                    // return <option value={pattern.id}>{sectionType === "school" ? pattern.exam_pattern_name : pattern.examPatternDetails.exam_pattern_name}</option>
                                    return <option value={pattern.id}>{pattern.exam_pattern_name}</option>
                                })
                            }
                        </select>
                        <ErrorMessage errors={errors} field="pattern_id" />
                    </div>

                    <div className="col-md-6">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Exam Type</label>
                        <select class="form-select" aria-label="Default select example" name='test_type_id' onChange={handleInputChange} value={assignExamData.test_type_id}>
                            <option selected value={''} disabled>Select Exam Type</option>
                            {
                                examType?.map((exam) => {
                                    return <option value={exam.id}>{exam.examName}</option>
                                })
                            }
                        </select>
                        <ErrorMessage errors={errors} field="test_type_id" />
                    </div>

                    <div className="col-md-6">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name</label>
                        <input type="text" className="form-control" id="exam_id" name='exam_id' disabled value={assignExamData.exam_id && examData.length > 0 ? getExamName(assignExamData.exam_id) : ''} /*onChange={handleInputChange}*/ />
                    </div>

                    <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Total No Of Question</label>
                        <input disabled type="text" className="form-control" id="total_questions" name='total_questions' value={assignExamData.total_questions} onChange={handleInputChange} />
                    </div>

                    {/* {sectionType == "school" && <>
                        <div className="col-md-6 ">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Possitive marks for correct answer</label>
                            <input type="text" disabled className="form-control" id="positive_marks" name='positive_marks' value={assignExamData.positive_marks} onChange={handleInputChange} />
                        </div>

                        <div className="col-md-6 ">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Negative marks for incorrect answer</label>
                            <input type="text" disabled className="form-control" id="negative_marks" name='negative_marks' value={assignExamData.negative_marks} onChange={handleInputChange} />
                        </div></>} */}
                    <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Possitive marks for correct answer</label>
                        <input type="text" disabled className="form-control" id="positive_marks" name='positive_marks' value={assignExamData.positive_marks} onChange={handleInputChange} />
                    </div>

                    <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Negative marks for incorrect answer</label>
                        <input type="text" disabled className="form-control" id="negative_marks" name='negative_marks' value={assignExamData.negative_marks} onChange={handleInputChange} />
                    </div>

                    <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Total Exam marks</label>
                        <input type="text" disabled className="form-control" id="total_exam_marks" name='total_exam_marks' value={assignExamData.total_exam_marks} onChange={handleInputChange} />

                    </div>

                    <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Ideal Time/question (Enter in seconds)</label>
                        <input type="text" className="form-control" id="ideal_time_per_question" name='ideal_time_per_question' value={assignExamData.ideal_time_per_question} onChange={handleInputChange} />
                        <ErrorMessage errors={errors} field="ideal_time_per_question" />
                    </div>

                    <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Passing marks</label>
                        <input type="number" className="form-control" id="passing_marks" name='passing_marks' value={assignExamData.passing_marks} onChange={handleInputChange} />
                        <ErrorMessage errors={errors} field="passing_marks" />
                    </div>

                    <div className="col-md-6">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Assign Class</label>
                        <select required class="form-select" aria-label="Default select example" name='class_id' value={assignExamData.class_id} onChange={handleGradeChange} >
                            <option selected value={''} disabled>Assign Class</option>
                            {
                                gradeList?.map((grade) => {
                                    return <option value={grade.id}>{grade.gradeName}</option>
                                })
                            }

                        </select>
                        <ErrorMessage errors={errors} field="class_id" />
                    </div>

                    <div className="col-md-6">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Assign Division</label>
                        <Select
                            value={divisionSelectList?.filter(option =>
                                assignExamData.divisions && assignExamData.divisions?.includes(option.value.toString())
                            )}
                            isMulti
                            name="divisions"
                            options={divisionSelectList}
                            className="basic-multi-select"
                            classNamePrefix="Select Medium"
                            onChange={handleChangeDivision}
                        />
                        <ErrorMessage errors={errors} field="divisions" />
                    </div>

                    <div className="col-md-12 view_content_radio_btn">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Choose Password Type: </label>
                        <label>
                            <input type="radio" name="password_type" value="R" checked={assignExamData.password_type == "R"} onChange={handleInputChange} /> &nbsp;Random
                        </label>
                        <label>
                            <input type="radio" name="password_type" value="M" checked={assignExamData.password_type == "M"} onChange={handleInputChange} /> &nbsp;Manual
                        </label>
                    </div>

                    {assignExamData.password_type === "M" && <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Password</label>
                        <input type="text" className="form-control" id="password" name='password' value={assignExamData.password} onChange={handleInputChange} />
                        <ErrorMessage errors={errors} field="password" />
                    </div>}

                    <div className="col-md-12 view_content_radio_btn">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Choose Re Exam Password Type: </label>
                        <label>
                            <input type="radio" name="re_exam_password_type" value="R" checked={assignExamData.re_exam_password_type == "R"} onChange={handleInputChange} /> &nbsp;Random
                        </label>
                        <label>
                            <input type="radio" name="re_exam_password_type" value="M" checked={assignExamData.re_exam_password_type == "M"} onChange={handleInputChange} /> &nbsp;Manual
                        </label>
                    </div>

                    {assignExamData.re_exam_password_type === "M" && <div className="col-md-6 ">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Re Exam Password</label>
                        <input type="text" className="form-control" id="re_exam_password" name='re_exam_password' value={assignExamData.re_exam_password} onChange={handleInputChange} />
                        <ErrorMessage errors={errors} field="re_exam_password" />
                    </div>}

                    <div className="col-md-6">
                        <label for="exam_mode" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Exam Mode</label>
                        <select class="form-select" aria-label="Default select example" name='exam_mode' onChange={handleInputChange} value={assignExamData.exam_mode}>
                            <option selected value={1}>Offline</option>
                            <option value={2}>Online</option>
                            <option value={3}>Both (Online + Offline)</option>
                        </select>
                        <ErrorMessage errors={errors} field="exam_mode" />
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className="col-md-12">
                        <label for="result_show" className="col-form-label">Publish Result Instantly</label>
                        <input type="checkbox" id="result_show" name='result_show' checked={assignExamData.result_show} value={assignExamData.result_show} onChange={handleInputChange} />
                    </div>

                    {!assignExamData.result_show && <>
                        <div className="col-md-6 ">
                            <label for="result_publish_date" className="col-form-label"><span style={{ color: "red" }}>*</span>Result Publish Date</label>
                            <input type="date" className="form-control" id="result_publish_date" name='result_publish_date' min={today} value={assignExamData.result_publish_date} onChange={handleInputChange} />
                            <ErrorMessage errors={errors} field="result_publish_date" />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="result_publish_time" className="col-form-label"><span style={{ color: "red" }}>*</span>Result Publish Time</label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['TimePicker', 'TimePicker']}>
                                    <TimePicker
                                        value={dayjs(assignExamData.result_publish_time, 'h:mm A')}
                                        onChange={(newTime) => handleInputResultPublishTimeChange(newTime)}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <ErrorMessage errors={errors} field="result_publish_time" />
                        </div></>}
                </div>
                <div>
                    <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                        <div className="col-auto new_button">
                            {!editId && <button className="btn btn-success" style={{ marginRight: '20px' }} type="button" onClick={assignExam}>Save</button>
                            }
                            <button className="btn btn-danger delete_icon delete_icon " type="button" style={{ marginRight: "20px" }} onClick={handleReset}>Reset</button>
                            {
                                editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateExam} disabled={!editId}>Update</button>)
                            }
                        </div>
                    </div>
                </div>
            </CModal>

            {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}

            {viewPdf && (
                <CModal
                    backdrop="static"
                    visible={viewPdf}
                    onClose={() => setVisibleImage(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <div className="row">
                        <div className='popoup-title text-center w-100'><h3>PDF</h3></div>
                        {/* <button type="button" className="btn-close" aria-label="Close" onClick={() => setViewPdf(false)}></button> */}
                    </div>
                    <div className="book book-modal">

                        <div className="pdf-container page">
                            <iframe
                                src={viewPdfUrl}
                                width="100%"
                                height="500px"
                                title="PDF Viewer"
                            />
                        </div>
                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setViewPdf(false)}>
                            Close
                        </button>
                    </div>
                </CModal>
            )}

            <CModal
                backdrop="static"
                visible={visibleView}
                onClose={() => setVisibleView(false)}
                aria-labelledby="LiveDemoExampleLabel"
                className="assign-modal"
                size="xl"
            >
                <div className="modal-header" style={{ borderBottom: 'none', padding: '0.5rem', position: 'relative' }}>
                    <h3 className="modal-title" style={{ fontWeight: "bold", fontSize: "1.25rem", margin: '0 auto' }}>
                        Exam Question Details
                    </h3>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => {
                            setVisibleView(false);
                            setExamDetails([]);
                        }}
                        style={{ position: 'absolute', right: '1rem', top: '0.5rem', zIndex: 10 }} // Ensure button is on top
                    ></button>
                </div>

                <div className="modal-body" style={{ padding: '1rem', maxHeight: '90vh', overflowY: 'auto' }}>
                    <div className="table-responsive">
                        <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                            <table className="table table-hover table-bordered align-middle">
                                <thead className="table-primary" style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#f8f9fa' }}>
                                    <tr>
                                        <th scope="col" className="text-center">Sr. No.</th>
                                        <th scope="col">Subject Name</th>
                                        <th scope="col">Lesson Name</th>
                                        <th scope="col">Q_Level</th>
                                        <th scope="col">Q_Type</th>
                                        <th scope="col">Question</th>
                                        <th scope="col">Option A</th>
                                        <th scope="col">Option B</th>
                                        <th scope="col">Option C</th>
                                        <th scope="col">Option D</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {examDetails?.length > 0 ? (
                                        examDetails.map((question, index) => (
                                            <tr key={index}>
                                                <th scope="row" className="text-center">{index + 1}</th>
                                                <td>{question.subjectName}</td>
                                                <td>{question.lessonName}</td>
                                                <td>{question.q_level}</td>
                                                <td>{question.q_type}</td>
                                                <td>
                                                    <ViewImageAndText
                                                        inputString={question.question}
                                                        onViewImage={onViewImage}
                                                    />
                                                </td>
                                                <td>
                                                    <ViewImageAndText
                                                        inputString={question.option_a}
                                                        onViewImage={onViewImage}
                                                    />
                                                </td>
                                                <td>
                                                    <ViewImageAndText
                                                        inputString={question.option_b}
                                                        onViewImage={onViewImage}
                                                    />
                                                </td>
                                                <td>
                                                    <ViewImageAndText
                                                        inputString={question.option_c}
                                                        onViewImage={onViewImage}
                                                    />
                                                </td>
                                                <td>
                                                    <ViewImageAndText
                                                        inputString={question.option_d}
                                                        onViewImage={onViewImage}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                <strong>No Questions Available</strong>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </CModal>
        </>
    )
};

export default AssignExam;